import { FormattedMessage } from 'react-intl';

export const GameStatuses = {
  released: {
    label: (
      <FormattedMessage id="released" defaultMessage="Released" />
    ),
  },
  coming_soon: {
    label: (
      <FormattedMessage
        id="comingSoon"
        defaultMessage="Coming Soon"
      />
    ),
  },
  in_progress: {
    label: (
      <FormattedMessage
        id="inProgress"
        defaultMessage="In Progress"
      />
    ),
  },
};
